module.exports = __webpack_public_path__ + "static/media/add_documents.793948aa.svg";